import React, { Component } from 'react'
import axios from 'axios'
import MediaQuery from 'react-responsive'
import Img from 'gatsby-image'
import _ from 'lodash'
import labels from '../../data/labels.json'

import DatePicker from 'react-datepicker'
import moment from 'moment'

//Components
import Locations from './Locations'
import TimePicker from './TimePicker'

//CSS Loader
import './loader.css'

import 'react-datepicker/dist/react-datepicker.css'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'

import { backendURL } from '../../data/config.json'

class MainForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fetching: true,
      offices: [],
      date1: moment(),
      pick_up_time: '',
      pickup: '',
      date2: moment(),
      return: '',
      return_time: '',
      promo_code: '',
      pickup_schedule: '',
      return_schedule: '',
      
    }
    this.handleChangeDate1 = this.handleChangeDate1.bind(this)
    this.handleChangeDate2 = this.handleChangeDate2.bind(this)
    this.handleChangeCallback = this.handleChangeCallback.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.handleHighlightEmptyValues = this.handleHighlightEmptyValues.bind(this)
  }
  static getDerivedStateFromProps(props, state) {
    if (props.couponCode) {
      const newState = {
        promo_code: props.couponCode,
      }
      return newState
    }
    if (props.pickupLocation) {
      const newState = {
        pickup: props.pickupLocation,
      }
      return newState
    }
    return null
  }
  handleScroll(e = null) {
    if (e !== null) {
      const { pageY } = e
      console.log(pageY)
      if (pageY > 40) {
        this.setState({
          scroll: true,
        })
      } else {
        this.setState({
          scroll: false,
        })
      }
    }
  }
  componentDidMount() {
    this.fetchLocations()
    if (typeof document !== 'undefined') {
      window.addEventListener('handleScroll', this.handleScroll)
    }
  }
  fetchLocations() {
    let formData =
      '&action=getOficinas&lg=&empresa=BUDGETNI&mode=AJAX&username=BUDGETNI&password=BudgetNI@2020'
    axios({
      method: 'post',
      data: formData,
      config: {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      },
      url: 'https://api.budgetcentralamerica.com/rental_functions_sandbox.php',
    })
      .then(res => {
        console.log(res.data)
        this.setState({
          fetching: false,
          offices: res.data,
        })
      })
      .catch(err => {
        console.log(err)
      })
  }
  handleChangeDate1(date) {
    this.setState({
      date1: date,
    })
    console.log(this.state.date1)
  }
  handleChangeDate2(date) {
    this.setState({
      date2: date,
    })
  }
  handleChangeCallback(e) {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })


    if (name === 'pickup') {
      this.state.offices.filter(office => {
        office.ID === value
          ? this.setState({
              pickup_schedule: office.HORARIO,
            })
          : null
      })
    }


    if (name === 'return') {
      this.state.offices.filter(office => {
        office.ID === value
          ? this.setState({
              return_schedule: office.HORARIO,
            })
          : null
      })
    }
  }



  handleHighlightEmptyValues(value) {
    if (this.state.emptyValues && _.isEmpty(value)) {
      return 'highlight'
    }
    return null
  }
  hasEmptyValue() {
    const {
      pick_up_time,
      pickup,
      return: return_field,
      return_time,
    } = this.state
    const emptyValues = _.some(
      [pick_up_time, pickup, return_field, return_time],
      value => value === ''
    )
    if (emptyValues) {
      return true
    }
    return false
  }
  handleSubmit(e) {
    if (this.hasEmptyValue()) {
      e.preventDefault()
      return this.setState({
        emptyValues: true,
      })
    }
    return this.setState({
      emptyValues: false,
    })
  }
  renderFirstStage() {
    return (
      <React.Fragment>
        <div className={this.handleHighlightEmptyValues(this.state.pickup)}>
          <Locations
            payload={this.state.offices}
            onChange={this.handleChangeCallback}
            pickupLocation={this.state.pickup}
            inputName="pickup"
            label={labels.pickupLocation[this.props.lang]}
          />
        </div>
        <div
          className={
            this.state.scroll && this.state.pickup === '' ? 'hidden' : null
          }
        >
          <DatePicker
            //dateFormat="DD-MM-YYYY"
            dateFormat="YYYY-MM-DD"
            name="date1"
            selected={this.state.date1}
            onChange={this.handleChangeDate1}
            className="date-picker"
          />
        </div>
        <div
          className={
            this.state.scroll && this.state.pickup === '' ? 'hidden' : null
          }
        >
          <div
            className={this.handleHighlightEmptyValues(this.state.pick_up_time)}
          >
            <TimePicker
              onChange={this.handleChangeCallback}
              inputName="pick_up_time"
              label={labels.selectTime[this.props.lang]}
              offices={this.state.offices}
              selectedOffice={this.state.pickup}
              schedule={this.state.pickup_schedule}
            />
          </div>
        </div>
      </React.Fragment>
    )
  }
  renderSecondStage() {
    if (!_.isEmpty(this.state.pick_up_time) && !_.isEmpty(this.state.pickup)) {
      return (
        <React.Fragment>
          <div className={this.handleHighlightEmptyValues(this.state.return)}>
            <Locations
              
              payload={this.state.offices}
              onChange={this.handleChangeCallback}
              inputName="return"
              label={labels.dropoffLocation[this.props.lang]}
            />
          </div>
          <div>
            <DatePicker
              dateFormat="YYYY-MM-DD"
              name="date2"
              selected={this.state.date2}
              onChange={this.handleChangeDate2}
              className="date-picker"
            />
          </div>
          <div
            className={this.handleHighlightEmptyValues(this.state.return_time)}
          >
          <TimePicker
              onChange={this.handleChangeCallback}
              inputName="return_time"
              label={labels.selectTime[this.props.lang]}
              offices={this.state.offices}
              selectedOffice={this.state.return}
              schedule={this.state.return_schedule}
            />
          </div>
          <div>
            <input
              type="text"
              name="promo_code"
              placeholder="Coupon code"
              value={this.state.promo_code}
              onChange={this.handleChangeCallback}
            />
          </div>
        </React.Fragment>
      )
    }
    return null
  }
  render() {
    if (this.state.fetching) {
      return (
        <form className="block main-form">
          <div className="wrapper">
            <MediaQuery query="(min-width: 750px)">
              {this.props.image ? (
                <img
                  alt={this.props.image.title}
                  src={`${backendURL}${this.props.image.url}`}
                  style={{ zIndex: '-1', position: 'absolute' }}
                  className="main-bg"
                />
              ) : null}
            </MediaQuery>
            <div className="form-content">
              <div className="lds-spinner">
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
          </div>
        </form>
      )
    }
    return (
      <form
        name="frm_1"
        id="frm_1"
        action="https://budgetnicaragua.miweb.cr/reserve/proc_rental_info.php"
        method="post"
        encType="application/x-www-form-urlencoded"
        className="block main-form"
      >
        <div className="wrapper">
          <MediaQuery query="(min-width: 750px)">
            {this.props.image ? (
              <img
                alt={this.props.image.title}
                src={`${backendURL}${this.props.image.url}`}
                style={{ zIndex: '-1', position: 'absolute' }}
                className="main-bg"
              />
            ) : null}
          </MediaQuery>
          <div className="form-content">
            {this.state.emptyValues ? (
              <div className="errors">
                There are errors in the form. Please correct them and resubmit
                the form.
              </div>
            ) : null}
            <div className="grid-wrapper">
              {this.renderFirstStage()}
              {this.renderSecondStage()}
            </div>
            <div
              className={
                this.state.scroll && this.state.pickup === '' ? 'hidden' : null
              }
            >
              <button
                className="btn btn-default btn-main-form"
                onClick={this.handleSubmit}
              >
                {labels.selectCar[this.props.lang]}
              </button>
            </div>
          </div>
        </div>
      </form>
    )
  }
}
export default MainForm



// WEBPACK FOOTER //
// ./src/components/MainForm/index.js